<template lang="pug">

	div#header(:class="{'expanded' : expanded, 'collapsed' : !expanded}")

		i.mdi.mdi-close.action-icon(@click="expanded = false", v-show="expanded")

		img(@click="expanded = !expanded", src="./../assets/logo-sig-acre.png")


		.col-12.informacoes-sig(v-show="expanded")
			p.text-justify {{informacoes}}
			

</template>

<script>

import Config from '@/config.js';

export default {
	name: 'SigHeader',

	data () {

		return {
			expanded: false,
			informacoes: Config.informacoesSig
		};
	}
};

</script>

<style lang="scss"scoped>

@import "../styles/mixins.scss";
@import '../styles/variaveis';

#header {

	p {
		font-size: $header-font-size;
		margin-bottom: 0.5rem;
		color: $header-font-size;
	}

	position: absolute;
	cursor: default;
	background: white;
	border-bottom-left-radius: $default-border-radius;
	border-bottom-right-radius: $default-border-radius;
	@include box-shadow(0px, 3px, 6px, rgba(0,0,0,0.16)); //TODO: Extrair
	z-index: 1000;

	button {
		position: absolute;
		margin-top: $header-margin;
		margin-right: $header-margin;
		right: 0;
		cursor: pointer;
	}

	img {
		display: table;
		margin: auto;
		padding-top: $header-image-padding;
		cursor: pointer;
		margin-top: 2px;
	}

	&.expanded {
		
		width: $header-expanded-width;
		max-height: $header-expanded-max-height;
		left: 50%;
		margin-left: ($header-expanded-width / 2) * -1;

		.informacoes-sig {
			margin-top: $header-informacoes-margin;
			margin-bottom: $header-informacoes-margin;
			overflow-y: auto;
			height: 100%;
			width: 100%;
			max-height: $header-informacoes-max-height;
		}
	}

	&.collapsed {
		
		width: $header-collapsed-width;
		height: $header-collapsed-height;
		left: 50%;
		margin-left: ($header-collapsed-width / 2) * -1;
		
		.informacoes-sig {
			display: none
		}
	}

	.action-icon.mdi-close {
		position: absolute;
		top: 5px;
		right: 10px;
	}
}

</style>



// WEBPACK FOOTER //
// Header.vue?755015f6